var defaultImage = 'https://res.cloudinary.com/seekda/image/upload/f_auto,q_auto/v1701418704/seekda/noimage';
var SUPPORTED_REGION_LOCALES = {
  en: ['en-gb', 'en-ca']
};

export { SUPPORTED_REGION_LOCALES as S, defaultImage as d };
//# sourceMappingURL=general-2a8d8650.js.map
